import axios from "axios";
import React, { useState } from "react";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import Spinner from "../utilities/Spinner.jsx";
import config from "../../config/config";
import { FaFilePdf } from "react-icons/fa";
import useFetch from "../hooks/useFetch.js";
// import "./FormModal.css"; // Import your custom styles for FormModal

function FormModal() {
  const [show, setShow] = useState(false);
  const [data, setData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const allManuals = useFetch("manuals/");
  let manualsUrl = allManuals ? allManuals[0].document : "";
  const [manuals, setManuals] = React.useState(null);

  React.useEffect(() => {
    setManuals(allManuals);
  }, [allManuals, manuals]);

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  const handleClose = () => {
    setShow(false);
    setShowPrompt(false);
  };

  const handleShow = () => setShow(true);

  const handleChange = (e, name) => {
    const { value } = e.target;
    setData({ ...data, [name]: value });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const headers = {
      "Content-Type": "application/json",
    };

    try {
      setIsLoading(true);
      const response = await axios.post(`${config.baseURL}/inquiries/`, data, {
        headers: headers,
      });

      // Handle success response
      if (response.status === 201) {
        setIsLoading(false);
        setMessage(response.message);
        setShowPrompt(true);
        setTimeout(() => {
          setMessage(null);
          setData({
            name: "",
            email: "",
            subject: "",
            message: "",
          });
        }, 3000);
      }
    } catch (error) {
      // Handle error response
      setIsLoading(false);
      setMessage(error.message);
      setTimeout(() => {
        setMessage(null);
      }, 3000);
    }
  };

  return (
    <>
      <Button onClick={handleShow} className="custom-button-gradient">
        Get in Touch
      </Button>

      <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title className="custom-modal-title">Leave us a message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="text-center">
              {isLoading && <Spinner message="Sending" />}
              {message && (
                <span className="custom-success-message">{message}</span>
              )}
            </div>
            <Row>
              <Col>
                <Form.Label className="custom-form-label">Name</Form.Label>
                <Form.Control
                  placeholder="Name"
                  onChange={(e) => handleChange(e, "name")}
                />
              </Col>
              <Col>
                <Form.Label className="custom-form-label">Email</Form.Label>
                <Form.Control
                  placeholder="Email"
                  onChange={(e) => handleChange(e, "email")}
                />
              </Col>
            </Row>
            <Form.Group className="mb-3" controlId="subject">
              <Form.Label className="custom-form-label">Subject</Form.Label>
              <Form.Control
                placeholder="Subject"
                onChange={(e) => handleChange(e, "subject")}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="message">
              <Form.Label className="custom-form-label">Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                onChange={(e) => handleChange(e, "message")}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button className="custom-button-gradient" onClick={handleSubmit}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPrompt} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title className="custom-modal-title">Thank you for your message!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>We've received your message. You can now download the publishing guidelines:</p>
          <a
            href={manualsUrl}
            target="_blank" rel="noopener noreferrer"
            className="custom-button-gradient"
          >
            <FaFilePdf className="mr-2" />
            Download Guidelines
          </a>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default FormModal;
